export default {
  title: 'Default notifications',
  subtitle:
    "What the people each notification is meant for receive without having chosen anything. Each member's own choice always wins, and these settings concern nobody else.",
  loadFailed: 'The defaults could not be loaded.',
  audience: 'Default recipients: {audience}.',
  audiences: {
    administrators: "the organization's administrators",
    reviewers: 'the people who review registration requests',
    holders: 'the members whose role holds “{permission}”',
    workspaceSeat: 'the members of the workspace concerned',
    workspaceReader: 'the people who can open the workspace concerned',
    moderators: 'the people who moderate the workspace concerned',
    workspaceHolders: 'the members whose role in the workspace concerned holds “{permission}”',
    sellers: "the people who manage the channels' sales",
    websiteOperator: 'the owner of the channel concerned',
  },
  audienceSeparator: ' and ',
  roles: 'Roles concerned today: {roles}',
  noRoles: 'No role of the organization is part of it today.',
  platformDefault: 'Platform default: {value}',
  choices: {
    label: "The organization's choice",
    platform: 'Default',
    on: 'On',
    off: 'Off',
  },
  values: {
    on: 'on',
    off: 'off',
  },
  result: {
    on: 'Received by the people it is meant for, except those who turn it off.',
    off: 'Received only by the people who turn it on themselves.',
  },
  refusals: {
    mandatory: 'This notification is required by email: it cannot be turned off.',
    notSelectable: 'This channel is not available yet.',
    failed: 'The change could not be saved.',
  },
}
